package com.cybersoftsolution.cybersoftsolutionweb.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.api.upsertPost
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.dropDowns.CategoryDropdown
import com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor.Editor
import com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor.EditorControls
import com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor.getEditor
import com.cybersoftsolution.cybersoftsolutionweb.components.imageUploader.ImageUploader
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.AdminPageLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.IsAuthenticatedLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.switchs.MySwitch
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastContainer
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.Post
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.CreatePostUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.navigation.navigateTo
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.CreateStyle
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.getPostByIdUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getUserId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.categoryDropDownId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.createButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.subTitleId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.editorId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.titleId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import com.cybersoftsolution.cybersoftsolutionweb.utils.Utils.getLocalDateTime
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

object Device{
        @Composable
        fun isDesktop(): Boolean {
            val breakpoint = rememberBreakpoint()
            return breakpoint > Breakpoint.MD
        }
    }




    @Composable
    fun CreatePage(){

        val context = rememberPageContext()
        val scope = rememberCoroutineScope()

        var state by remember { mutableStateOf(CreatePostUI(
            post = Post(id = null)
        ))}
        var isLoading by remember { mutableStateOf(false) }
        val forceClearImageData by remember { mutableStateOf(false) }

        var postIdByParams by mutableStateOf( context.route.params[Post::id.name] )

        postIdByParams?.let { postId ->
            LaunchedEffect(Unit){
                scope.getPostByIdUseCase(
                    id = postId,
                    state = state,
                    setLoading = {
                        isLoading = it
                    },
                    setState = {
                        state = it
                    }
                )
            }
        }


        val modifierSwitch = Modifier
            .margin(
                leftRight = if (isDesktop()) {18.px} else {0.px},
                topBottom = if (isDesktop()) {0.px} else {12.px},
            )
        val modifierCategory = Modifier
            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
            .height(54.px)
            .padding(leftRight = 24.px)
            .margin(bottom = 12.px)
            .fontSize(14.px)




        AdminPageLayout(
            isLoading = isLoading,
        ){




            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top,
                modifier = Modifier
                    .fillMaxWidth(if (isDesktop()) {90.percent} else {95.percent})
//                    .height(100.vh)
                    .borderRadius(25.px)
//                    .border(
//                        width = 1.px,
//                        style = LineStyle.Solid,
//                        color = Theme.HalfBlack.rgb
//                    )
                    .margin(topBottom = 24.px)
                    .padding(topBottom = 25.px, leftRight = 8.px)
//                    .backgroundColor(Theme.LightGray.rgb)
            ){

//                SpanText( postIdByParams?: "Modo Creacion" )

                    SimpleGrid(
                        modifier = Modifier
//                            .fillMaxWidth()
                            .margin(bottom = 12.px),
                        numColumns = numColumns(base = 2, md = 3 )
                    ){

                        MySwitch(
                            isChecked = state.post.popular,
                            modifier = modifierSwitch,
                            text = "Popular",
                            onChange = {
                                state = state.copy(
                                    post = state.post.copy(
                                        popular = it
                                    )
                                )
                            }
                        )
                        MySwitch(
                            isChecked = state.post.favorite,
                            modifier = modifierSwitch,
                            text = "Favorito",
                            onChange = {
                                state = state.copy(
                                    post = state.post.copy(
                                        favorite = it
                                    )
                                )
                            }
                        )
                        MySwitch(
                            isChecked = state.post.visible,
                            modifier = modifierSwitch,
                            text = "Visible",
                            onChange = {
                                state = state.copy(
                                    post = state.post.copy(
                                        visible = it
                                    )
                                )
                            }
                        )

                    }

                    MyTextField(
                        modifier = Modifier
                            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
                            .height(54.px)
                            .padding(leftRight = 24.px)
                            .margin(bottom = 12.px)
                            .fontSize(16.px),
                        text = state.post.title,
                        style = CreateStyle,
                        inputTypeHTML = InputTypeHTML.Text,
                        id = titleId,
                        placeholder = "Titulo",
                        onChange = {
                            state = state.copy(
                                post = state.post.copy(
                                    title = it
                                )
                            )
                        }
                    )

                    MyTextField(
                        modifier = Modifier
                            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
                            .height(54.px)
                            .padding(leftRight = 24.px)
                            .margin(bottom = 12.px)
                            .fontSize(14.px),
                        text = state.post.subtitle,
                        style = CreateStyle,
                        inputTypeHTML = InputTypeHTML.Text,
                        id = subTitleId,
                        placeholder = "Sub titulo",
                        onChange = {
                            state = state.copy(
                                post = state.post.copy(
                                    subtitle = it
                                )
                            )
                        }
                    )


                    CategoryDropdown(
                        modifier = modifierCategory,
                        placeholder = "Seleccione la Categoria",
//                        style = MyCheckBoxStyle,
                        style = CreateStyle,
                        selectedCategory = state.post.category,
                        id = categoryDropDownId,
                        onCategorySelected = {
                                state = state.copy(
                                    post = state.post.copy(
                                        category = it
                                    )
                                )
                            }
                    )


                    Box(
                        contentAlignment = Alignment.CenterStart,
                        modifier = modifierCategory

                    ) {
                        MySwitch(
                            isChecked = state.useImageFromUrl,
                            text = "Usar Imagen desde URL",
                            onChange = {
                                state = state.copy(useImageFromUrl = it)
                            }
                        )
                    }


                    ImageUploader(
                        data = state.post.image.orEmpty(),
                        forceClear = forceClearImageData,
                        inputDisabled = state.useImageFromUrl,
                         onImageSelected = { data ->
                                 state = state.copy(
                                     post = state.post.copy(
                                         image = data
                                     )
                                 )
                        }
                    )


                    EditorControls(
                        editorId = editorId,
                        modifier = Modifier
                            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
                            .backgroundColor(Theme.LightGray.rgb),
                        onPreviewClick = {
                            state = state.copy(
                                post = state.post.copy(
                                    content = getEditor(id = editorId).value
                                ),
                                editorVisibility = !state.editorVisibility
                            )
                        },
                        editorVisibility = state.editorVisibility,
                    )

                    Editor(
                        text = state.post.content.orEmpty(),
                        modifier = Modifier
                            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
                            .height(400.px)
                            .margin(bottom = 24.px),
                        id = editorId,
                        editorVisibility = state.editorVisibility,
                        onChange = {
                            state = state.copy(
                                post = state.post.copy(
                                    content = it
                                )
                            )
                        }
                    )

                    MyButton(
                        id = createButtonId,
                        modifier = Modifier
                            .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent})
                            .height(68.px)
                            .fontSize(FontSize.Larger)
                        ,
                        text = if (postIdByParams!=null) "Actualizar" else "Publicar",
                        onClick = {

                            if (state.post.title.isNullOrEmpty() || state.post.subtitle.isNullOrEmpty() || state.post.content.isNullOrEmpty() || state.post.image.isNullOrEmpty()){
                                state = state.copy(
                                    toastMessage = ToastMessage(
                                        message = "Por favor complete todos los campos",
                                        style = MyToastStyle.Danger
                                    )
                                ).also {
                                    scope.showMyToast(toastBasicID)
                                }

                            } else {
                                scope.launch {

                                    isLoading = true

                                    upsertPost(
                                        post = state.post.copy(
                                            date = getLocalDateTime(),
                                            userId = state.post.userId.orEmpty().ifEmpty { getUserId() }
                                        )
                                    )
                                    .also { response ->


                                        delay(500)
                                        isLoading = false

                                        console.log(response)

                                        if (response!=null){


                                            state = CreatePostUI().copy(
                                                post = Post(),
                                                toastMessage = ToastMessage(
                                                    message = "Publicacion ${if (postIdByParams!=null) "editada" else "creada"} satisfactoriamente",
                                                    style = MyToastStyle.Success
                                                )
                                            ).also {
                                                postIdByParams = null
                                                scope.showMyToast(toastBasicID)
                                                scope.launch {
                                                    delay(500)
                                                    context.navigateTo(Screen.AdminCreate)
                                                }
                                            }

                                        } else {
                                            state = state.copy(
                                                toastMessage = ToastMessage(
                                                    message = "Error al ${if (postIdByParams!=null) "editar" else "crear"} la publicacion",
                                                    style = MyToastStyle.Danger
                                                )
                                            ).also {
                                                scope.showMyToast(toastBasicID)
                                            }
                                        }

                                    }


                                }
                            }







                        }

                    )










            }


            MyToastContainer{
                MyToastMessage(
                    id = toastBasicID,
                    message = state.toastMessage.message,
                    style = state.toastMessage.style
                )

            }


        }

    }



    @Composable
    @Page(routeOverride = "create")
    fun create() {

    IsAuthenticatedLayout(delay = 0L, asAdmin = true) {
        CreatePage()
    }



    }